/**
 * Get all the properties (of a geojson feature properties).
 */
import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'
import toLower from 'lodash/toLower'

import GetPropertiesIdKey from './GetPropertiesIdKey'

export default function (layer, p) {
  if (isNil(layer) || isNil(p) || !isObject(p)) {
    console.log('Invalid layer or properties object!')
    return null
  }
  const idKey = GetPropertiesIdKey(layer, p)
  if (isNil(idKey) || idKey === '') {
    // console.log('Unable to find a valid property id key!')

    return null
  }
  const idKeyLower = toLower(idKey)
  for (const key in p) {
    if (Object.hasOwnProperty.call(p, key)) {
      if (toLower(key) === idKeyLower) {
        return p[key]
      }
    }
  }
  return null
}
